<template>
  <!--  <img src="https://img.alicdn.com/imgextra/i2/O1CN01DhnOzu1KcJf4M74Eo_!!6000000001184-0-tps-1470-700.jpg" style="width: 100%">-->
  <div class="createdforyou" style="text-align: left">
    <div class="mt-3">
      <div class="container">
        <div>
          <div class="contents_body">
            <div class="sectionHead2"><b>{{this.category_name}}</b></div>
            <div class="wrapper">
              <!-- {{this.this.InspirationalProductsList}} -->
              <h5
                style="color: #b4b4b4;margin-left: 23%;margin-top: 25%;"
                v-if="
                  !InspirationalProductsList ||
                    !InspirationalProductsList.length
                "
              >
               No Products Available..
              </h5>
              <div
                class="card"
                v-for="List in InspirationalProductsList"
                :key="List.id"
              >
                <a :href="List.Product_URL">
                  <div>
                    <img
                      :src="List.Thumbnail.url"
                      style="width: 100%;border-radius: 16px;"
                    />

                    <div class="discount">
                      <div class="discount-text ">
                        <span>{{ List.Price }}</span>
                      </div>
                    </div>

                    <p class="mercText">{{ List.Product_Name }}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toVue3 from "vue-2-3/to-vue-3";
import Vue2 from "vue2";
import * as Vue3 from "vue";
toVue3.register(Vue2, Vue3);
import Strapi from "../services/strapi-services.js";
const strapi = new Strapi();
export default {
  name: "MobCreatedForYou",
  components: {},
  data() {
    return {
      finalId: 0,
      cattype: "deals",
      i: 0,
      InspirationalProductsList: [],
      noData: false,
      category_name:"",
    };
  },
  computed: {
  },
  created() {
    document.title = "Deals @ Koko";
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    this.category_name =
      params
        .get("title")
        .charAt(0)
        .toUpperCase() + params.get("title").slice(1);

    this.getInpiratonalListDataBySlug();
  },
  methods: {
    getInpiratonalListDataBySlug() {
      let parameter = this.$route.query.type;
      // let parameter =JSON.stringify(params)
      // console.log("__ROUTER_PARAMS :", parameter);

      if (parameter === "all") {
        strapi
          .getInspirationalAllProducts(parameter)
          .then((res) => {
            this.InspirationalProductsList = res.data;
            // console.log("__PRODUCTS_ALL_LIST:", this.InspirationalProductsList);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        strapi
          .getInspirationalProductsBySlug(parameter)
          .then((res) => {
            this.InspirationalProductsList = res.data;
            // console.log("__PRODUCTS_LIST:", this.InspirationalProductsList);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
};
</script>

<style scoped>
.createdforyou {
  /* background-image: url("https://img.alicdn.com/imgextra/i3/O1CN015GVXHD1TheqsA37sf_!!6000000002414-0-tps-1080-1920.jpg"); */
  position: relative;
  filter: grayscale(30%);
}
.text {
  color: #1b1b1b;
  font-size: 30px;
  font-family: "Pacifico", cursive;
  text-align: left;
  margin-top: 4%;
  margin-bottom: 4%;
  margin-left: 5%;
}
.sectionHead2 {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  text-align: left;
  /* line-height: 42px; */
  margin-top: 15px;
  color: #393939;
  margin-left: 5%;
  padding-top: 3%;
}
.sectionHead {
  font-family: Lato;
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  /* line-height: 42px; */
  color: #393939;
  margin-top: 2%;
  margin-left: 2%;
  margin-right: 2%;
  background-color: #f7f4f09c;
  border-radius: 16px;
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
  text-align: center;
}
.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;
  opacity: 0.8;
}
.contents_body {
  margin-top: 3%;
  width: 100%;
}
.tech_body {
  margin-top: 3%;
  width: 100%;
}
.fitness_body {
  margin-top: 3%;
  width: 100%;
}
.header_design {
  background-color: #ffcce2;
}
.container {
  position: relative;
  text-align: center;
}
.bottom-left {
  position: absolute;
  bottom: 8px;
  left: 16px;
}
.top-left {
  position: absolute;
  top: 22%;
  left: 16px;
}
.top-right {
  position: absolute;
  top: 8px;
  right: 40%;
}
.bottom-right {
  position: absolute;
  bottom: 8px;
  right: 16px;
}
.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
}
.search-wrapper {
  position: relative;
}
.search-wrapper label {
  position: absolute;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  top: 8px;
  left: 12px;
  z-index: -1;
  transition: 0.15s all ease-in-out;
}
.search-wrapper input {
  padding: 4px 12px;
  color: rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(0, 0, 0, 0.12);
  transition: 0.15s all ease-in-out;
  background: white;
}
.search-wrapper input:focus {
  outline: none;
  transform: scale(1.05);
}
.search-wrapper input:focus + label {
  font-size: 10px;
  transform: translateY(-24px) translateX(-12px);
}
.search-wrapper input::-webkit-input-placeholder {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 100;
}
.wrapper {
  display: flex;
  max-width: 444px;
  flex-wrap: wrap;
  padding-top: 12px;
}
.card {
  box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px,
    rgba(0, 0, 0, 0.117647) 0px 1px 4px;
  max-width: 41%;
  margin: 15px;
  transition: 0.15s all ease-in-out;
  border-radius: 16px;
}
.card:hover {
  transform: scale(1.1);
}
.card a {
  text-decoration: none;
  padding: 12px;
  color: #03a9f4;
  font-size: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card a img {
  height: 100px;
}
.card a small {
  font-size: 10px;
  padding: 4px;
}
.hotpink {
  background: hotpink;
}
.green {
  background: green;
}
.box {
  width: 100px;
  height: 100px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

/* Created for you component styles */

.search-wrapper {
  position: relative;
}
.search-wrapper label {
  position: absolute;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  top: 8px;
  left: 12px;
  z-index: -1;
  transition: 0.15s all ease-in-out;
}
.search-wrapper input {
  padding: 4px 12px;
  color: rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(0, 0, 0, 0.12);
  transition: 0.15s all ease-in-out;
  background: white;
}
.search-wrapper input:focus {
  outline: none;
  transform: scale(1.05);
}
.search-wrapper input:focus + label {
  font-size: 10px;
  transform: translateY(-24px) translateX(-12px);
}
.search-wrapper input::-webkit-input-placeholder {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 100;
}
.wrapper {
  display: flex;
  max-width: 444px;
  flex-wrap: wrap;
  padding-top: 12px;
}
.card {
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
  max-width: 41%;
  margin: 15px;
  border-radius: 16px;
  transition: 0.15s all ease-in-out;
}
.card:hover {
  transform: scale(1.1);
}
.card a {
  text-decoration: none;
  padding: 12px;
  color: #03a9f4;
  font-size: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card a img {
  height: 200px;
}
.card a small {
  font-size: 10px;
  padding: 4px;
}
.hotpink {
  background: hotpink;
}
.green {
  background: green;
}
.box {
  width: 100px;
  height: 100px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.card3 {
  display: grid;
  place-content: center;
  font-size: 1.5rem;
  height: 100%;
  width: 137px;
  margin-top: 17%;
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
  border-radius: 16px;
  margin-left: 10%;
}
.mercText {
  font-family: Raleway;
  font-style: normal;
  font-weight: 200;
  font-size: 13px;
  color: #393939;
  margin-top: 2%;
  margin-left: 1%;
  margin-right: 1%;
}

.discount {
  position: relative;
  z-index: 1000;
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 10px;
  border-radius: 16px;
  margin-top: -15%;
  width: 147px;
}
.discount .discount-text {
  color: #fff;
  background: #242424;
  font-size: 13px;
  padding: 8px;
  font-weight: bold;
  font-family: Raleway;
  border-radius: 16px;
}
.discount .discount-text span {
  display: block;
  font-size: 11px;
}
</style>
